<template>
  <section
    v-if="footerItems"
    class="bg-primary-darker py-10 px-4 flex flex-col items-center gap-6"
  >
    <div class="text-2xl text-primary-lightest text-center">
      {{ $t("professionLinks.deepLinks") }}
    </div>
    <ul
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-10 gap-y-2 w-full max-w-4xl text-center"
    >
      <li v-for="item in footerItems" :key="item.id">
        <NuxtLink
          :to="item.to"
          class="text-white hover:text-primary-lighter"
          @click.native="trackClick(item.id)"
        >
          {{ item.text }}
        </NuxtLink>
      </li>
    </ul>
  </section>
</template>

<script>
import { useContext } from "@nuxtjs/composition-api";
import { useProfessionNavLinks } from "~/composables/useProfessionNavLinks";

export default {
  setup() {
    const { $trackers } = useContext();
    const { footerItems } = useProfessionNavLinks();

    const trackClick = (itemId) => {
      $trackers.trackClick("ProfessionDeepLinks", { itemId });
    };

    return { footerItems, trackClick };
  },
};
</script>
